export enum ZbvLoginStatus {
  NONE = 'NONE',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  ERROR = 'ERROR',
}
